import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

import { Input } from '@yuhu-inc/yuhui';

const StyledLabel = styled.label`
  margin-top: 10px;
`;

const StyledInput = styled(Input)`
  border-radius: 5px !important;
  border: 1px solid #d0dbfd !important;
  &:focus {
    outline: none !important;
    border-color: #230cc2 !important;
  }
`;

const StyledError = styled.div`
  color: red;
  margin-top: 5px;
`;

const TemplateName = ({ values, errors, touched, setFieldValue }) => {
  return (
    <React.Fragment>
      <StyledLabel>
        {getTranslatedString('landlordPortal.documentTemplate.nameYourTemplate')}
      </StyledLabel>
      <StyledInput
        type="text"
        name="title"
        value={values.title}
        contentKey={'landlordPortal.documentTemplate.documentTemplateName'}
        onChange={(e) => setFieldValue('title', e.target.value)}
      />
      {errors.title && touched.title ? <StyledError>{errors.title}</StyledError> : null}
    </React.Fragment>
  );
};

export default TemplateName;
